<template>
    <div class="dv5-shared-collapse">
        <div class="dv5-collapse-header" @click="collpaseToggle">
            <div>
                <slot name="title" :title="view.name" :title-class="`dv5-collapse-header-title ${collapsed ? 'text-primary' : ''}`">
                    <span :class="['dv5-collapse-header-title', collapsed ? 'text-primary' : '']">{{view.name}}</span> <!-- default value -->
                </slot>
            </div>
            <div>
                <i :class="['fa fa-chevron-down', !collapsed ? '' : 'rotate-180']" ></i>
            </div>
        </div>
        <div class="dv5-separator" />
        <div class="dv5-collapse-content section" :class="{ 'collapsed': !collapsed }">
            <slot name="content" :content="view.content">
                <div id="div_exemplo">{{view.content}}</div> <!-- default value -->
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "dv5-collapse-mobile",
        props: {
        view: {
            type: Object,
        },
        toolsSelected: {
            type: Function
        },
        options: {
            type: Array
        }
    },
    data: function() {
        return {
            collapsed: false
        }
    },

    methods: {
        collpaseToggle(){
            let filterSelected = null
            this.collapsed = !this.collapsed
            if (this.collapsed) {
                filterSelected = this.options.indexOf(this.view)
                this.toolsSelected(filterSelected)
            }
        }
    },
    watch: {
    }
}
</script>

<style scoped lang="scss">
@import '../../../../scss/extras/_variables';
.section {
    overflow:hidden;
    transition:max-height .8s;
    height:auto;
    max-height: 1800px;
}
.section.collapsed {
    transition: .8s;
    max-height:0;
    padding: 0 0 !important;
}
.dv5-shared-collapse{
    font: inherit;
    //padding: 1.4em 6em 0em 6em;
    display: flex;
    flex-direction: column;

    .dv5-collapse-header{
        font: inherit;
        background-color: $dv5-color4;
        padding: 1.2em 2.4em;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;

        &:hover{
            cursor: pointer;
        }
        div{
            font: inherit;
            .dv5-collapse-header-title{
                font: inherit;
                font-size: 1.1em;
                color: $dv5-color2;
                font-weight: 800;
                text-transform: uppercase;
                margin-right: 0.777777778em;
                display: inline-block;
                transition: color .3s ease-in-out;
            }
            .dv5-collapse-header-subtitle{
                font: inherit;
                font-size: 1.4em;
                color: $dv5-color3;
                font-weight: 800;
                display: inline-block;
            }
            i{
                font-size: 1em;
                color: $dv5-color1;
            }
        }
    }
    .dv5-separator {
        width: 100%;
        background-color: #ffffff;
    }
    .dv5-separator:after {
        content: "";
        display: block;
        width: 94%;
        margin: 0 auto;
        border-bottom: 1px solid #7070703d;
    }
    .dv5-collapse-content{
        font: inherit;

        padding: 2.4em 2.4em 0;
        margin: 0 -6.8em;
    }
}

.text-primary{
    color: $dv5-color1!important;
}
.rotate-180{
    transform: rotate(-180deg);
}
.fa-chevron-down{
    transition: transform .3s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/shared/CollapseToolsFilter.vue